<div class="filter-bar">
  <ng-container 
    [ngTemplateOutlet]="filterBarItem"
    [ngTemplateOutletContext]="{
      $implicit: {
        toggleFunction: toggleLabelFilterItem.bind(this), 
        filterItems: labelFilterItems$ | async | sortString: 'name',
        title: labelGroupTitle
      }
    }"
  ></ng-container>
  <ng-container 
    [ngTemplateOutlet]="filterBarItem"
    [ngTemplateOutletContext]="{
      $implicit: {
        toggleFunction: toggleAllergenFilterItem.bind(this), 
        filterItems: allergenFilterItems$ | async | sortString: 'name',
        title: allergenGroupTitle
      }
    }"
  ></ng-container>

  <ng-template #filterBarItem let-context>
    <div class="filter-bar__title" *ngIf="context.filterItems.length">{{context.title}}</div>
    <div class="filter-bar__container">
      <ng-container *ngFor="let item of context.filterItems">
        <div class="filter-bar__item" [class.active]="item.isActive" (click)="context.toggleFunction(item.name)">
          <span>{{ item.name }}</span>
          <span class="filter-item__icon" *ngIf="item.isActive">
            <i class="icomoon icomoon--close"></i>
          </span>
        </div>
      </ng-container>
    </div>
  </ng-template>
</div>